import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class DisneyPlusLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames=['logo', 'disneyPlusLogo'];
    if (this.props.isPrimary) {classNames.push('primaryLogo');}
    return (
      <svg className={classNames.join(' ')} viewBox="0 0 906.1 495" aria-labelledby='epsn-plus-logo-title' role='img'>
        <g id="Layer_2" className="st0" style={{display:"none"}}>
          <rect x="-87.5" y="-172.4" className="st1" style={{display: "inline", stroke: "#FFFFFF", "stroke miterlimit": 10}} width="1312" height="878" />
        </g>
        <g id="Layer_1">
          <g>
            <g>
              <g>
                <path className="st2" style={{fill: "#FFFFFF"}} d="M639.1,319c-12.5,2.9-45.3,4.5-45.3,4.5l-4.1,13c0,0,16.4-1.4,28.3-0.2c0,0,3.9-0.4,4.3,4.4
              c0.2,4.5-0.4,9.3-0.4,9.3s-0.3,2.9-4.4,3.7c-4.5,0.8-35.3,1.9-35.3,1.9l-5,16.9c0,0-1.9,3.9,2.3,2.8c3.9-1,36.2-7.1,40.4-6.2
              c4.5,1.1,9.5,7.1,8.1,12.6c-1.7,6.8-34,27.3-53.6,25.9c0,0-10.3,0.7-19-13.3c-8.1-13.3,3.1-38.4,3.1-38.4s-5.1-11.7-1.4-15.7
              c0,0,2.2-2,8.7-2.5l7.9-16.3c0,0-9,0.6-14.4-6c-5-6.3-5.4-9.2-1.6-10.9c4.1-2,41.6-8.9,67.3-8c0,0,9-0.9,16.7,14.7
              C641.7,311.2,645.5,317.5,639.1,319L639.1,319z M542.1,381.8c-3.3,7.8-12,16.1-22.9,10.9c-10.7-5.2-27.8-40.1-27.8-40.1
              s-6.5-13-7.7-12.7c0,0-1.4-2.5-2.3,11.7c-0.9,14.2,0.2,41.8-5.5,46.1c-5.3,4.4-11.8,2.6-15.2-2.5c-3.1-5-4.3-16.9-2.7-37.9
              c2-21,6.8-43.3,13.1-50.2c6.2-6.9,11.2-1.9,13.2-0.1c0,0,8.3,7.5,22,29.7l2.4,4.1c0,0,12.5,20.9,13.8,20.9c0,0,1,1,1.9,0.3
              c1.3-0.4,0.8-7.1,0.8-7.1s-2.6-22.8-13.9-61.4c0,0-1.7-4.8-0.6-9.3c1.2-4.6,5.7-2.4,5.7-2.4s17.6,8.9,26.2,37.5
              C551.2,348.1,545.5,374,542.1,381.8L542.1,381.8z M455.5,308c-1.5,2.9-2.3,7.2-9.7,8.3c0,0-71.2,4.9-74.6,9.9c0,0-2.5,3,1.4,3.8
              c3.9,0.8,20,3,27.7,3.4c8.3,0.1,36.3,0.3,46.3,12.9c0,0,5.9,5.9,5.7,19.4c-0.3,13.8-2.7,18.7-8,23.7c-5.7,4.7-53.9,26.3-85.1-7
              c0,0-14.3-16,4.9-28.1c0,0,14-8.4,49.3,1.5c0,0,10.7,3.9,10.2,7.8c-0.6,4.2-8.8,8.6-20.7,8.3c-11.6-0.3-20.1-5.9-18.5-5
              c1.6,0.6-12.4-6.7-16.8-1.8c-4.3,4.6-3.3,7.5,0.9,10.3c10.8,6.1,52.6,4,65.1-9.9c0,0,4.9-5.6-2.6-10.2
              c-7.5-4.3-29.1-6.9-37.5-7.3c-8.1-0.4-37.9,0.1-42.3-7.8c0,0-4.3-5.3,0.4-20.6c5-15.9,39.9-22,55-23.4c0,0,41.4-1.4,49.1,7
              C455.7,303.2,456.7,305.1,455.5,308L455.5,308z M337.8,401.3c-5.1,3.7-15.7,2.1-18.7-2.1c-3-3.8-4.1-18.5-3.4-41.7
              c0.6-23.5,1.1-52.5,6.1-57.1c5.4-4.7,8.7-0.6,10.7,2.6c2.3,3.1,5,6.6,5.5,14c0.5,7.4,2.2,45.9,2.2,45.9S342.5,397.7,337.8,401.3
              L337.8,401.3z M348.6,277c-14.6,4.9-24.7,3.2-33.1-0.4c-3.7,6.5-5.9,8.5-8.7,8.9c-4.2,0.4-7.9-6.2-8.6-8.4
              c-0.7-1.6-2.7-4.4-0.3-11c-8.3-7.5-8.9-17.4-7.5-24.2c2.1-7.8,16.1-37.4,58.7-40.9c0,0,20.8-1.5,24.4,9.6h0.6
              c0,0,20.3,0.1,19.8,18.1C393.7,246.8,371.5,269.3,348.6,277L348.6,277z M308.9,236.9c-4.3,6.9-4.5,11-2.5,13.9
              c4.9-7.5,13.9-19.3,27.1-28.4C323.3,223.3,314.7,227.7,308.9,236.9L308.9,236.9z M367.7,225.3c-13.4,2-34.1,19.9-44,34.7
              c15.2,2.8,41.9,1.7,53.7-22.4C377.3,237.6,383.1,222.6,367.7,225.3L367.7,225.3z M731.7,364.7c-8,14-30.7,43.3-60.8,36.4
              c-9.9,24.1-18.3,48.5-23.1,84.9c0,0-1,7.1-6.9,4.6c-5.8-2.1-15.5-11.8-17.4-25.2c-2.1-17.6,5.8-47.5,21.8-81.6
              c-4.7-7.6-7.9-18.5-5.1-34c0,0,4-28.7,32.9-54.7c0,0,3.5-3,5.5-2.1c2.2,0.9,1.2,10.3-0.6,14.8c-1.8,4.5-14.7,26.8-14.7,26.8
              s-8,15-5.8,26.9c15.1-23.3,49.6-70.2,70.9-55.4c7.2,5.1,10.5,16.3,10.5,28.3C739,345,736.4,356.2,731.7,364.7L731.7,364.7z
               M725.5,327.8c0,0-1.2-9.3-10.2,0.9c-7.8,8.6-21.8,24.7-33.1,46.6c11.9-1.3,23.3-7.8,26.7-11
              C714.5,359.3,727.6,345.8,725.5,327.8L725.5,327.8z M305.5,339.5c-1.6,20.9-9.7,56.2-66.7,73.6c-37.6,11.3-73.2,5.9-92.6,1
              c-0.4,7.7-1.3,11-2.5,12.3c-1.6,1.6-13.9,8.8-20.7-1.3c-3-4.8-4.5-13.4-5.4-21.1c-43.6-20-63.7-49-64.4-50.3
              c-1-0.9-10.9-11.3-1-24.1c9.3-11.5,39.9-23,67.4-27.6c0.9-23.5,3.7-41.3,7-49.4c3.9-9.4,9-0.9,13.3,5.4c3.7,4.7,5.8,25.2,6,41.7
              c18-0.8,28.6,0.5,48.7,4.1c26.1,4.8,43.6,18.1,42.1,33.2c-1.1,14.8-14.8,21-20,21.4c-5.5,0.5-13.9-3.4-13.9-3.4
              c-5.8-2.8-0.5-5.2,6.5-8.3c7.6-3.7,5.9-7.5,5.9-7.5c-2.8-8.3-36.8-14.1-70.5-14.1c-0.1,18.6,0.8,49.5,1.2,67.5
              c23.6,4.5,41.3,3.7,41.3,3.7s86.1-2.4,88.7-57.4c2.7-55.1-85.9-108-151.4-124.8c-65.4-17.2-102.4-5.2-105.6-3.5
              c-3.5,1.7-0.2,2.3-0.2,2.3s3.5,0.5,9.7,2.6c6.5,2.1,1.4,5.4,1.4,5.4c-11.1,3.5-23.7,1.3-26.1-3.8c-2.4-5.1,1.6-9.7,6.3-16.3
              c4.7-6.9,9.8-6.7,9.8-6.7c80.9-28,179.4,22.6,179.4,22.6C291.5,263.4,307.2,318.3,305.5,339.5L305.5,339.5z M61.4,336.7
              c-9.2,4.5-2.9,11-2.9,11c17.2,18.5,38.4,30.1,58.6,37.3c2.4-31.9,2-43.2,2.2-59.3C87.8,327.9,69.7,332.9,61.4,336.7L61.4,336.7z
              "/>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <path className="st2" style={{fill: "#FFFFFF"}} d="M903,330.2v11.5c0,2.5-2,4.5-4.5,4.5h-54.4c0,2.8,0.1,5.4,0.1,7.7c0,16.8-0.7,30.6-2.3,46.1
                c-0.2,2.3-2.1,4-4.4,4h-11.8c-1.2,0-2.3-0.5-3.1-1.4c-0.8-0.9-1.2-2.1-1.1-3.2c1.7-15.4,2.4-29,2.4-45.5c0-2.4,0-4.9-0.1-7.7
                h-53.8c-2.5,0-4.5-2-4.5-4.5v-11.5c0-2.5,2-4.5,4.5-4.5h53c-1.1-18.6-3.4-36.5-7-54.7c-0.2-1.1,0.1-2.2,0.8-3.1
                c0.7-0.9,1.8-1.4,2.9-1.4h12.7c2,0,3.7,1.4,4,3.4c3.6,18.8,5.8,37.1,6.9,55.8h55.1C901,325.7,903,327.7,903,330.2z"/>
                </g>
              </g>
            </g>
            <g>
              <g>
                <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="817.6351" y1="179.392" x2="181.4779"
                                y2="179.392">
                  <stop offset="7.086212e-03" style={{"stopColor":"#FFFFFF"}}/>
                  <stop offset="0.4787" style={{"stopColor":"#00FFFF","stopOpacity":"0.52"}}/>
                  <stop offset="0.5415" style={{"stopColor":"#00FFFF","stopOpacity":"0.4574"}}/>
                  <stop offset="0.6066" style={{"stopColor":"#00EEFF","stopOpacity":"0.3924"}}/>
                  <stop offset="0.6728" style={{"stopColor":"#00BCFF","stopOpacity":"0.3264"}}/>
                  <stop offset="0.7398" style={{"stopColor":"#00BCFF","stopOpacity":"0.2596"}}/>
                  <stop offset="0.8073" style={{"stopColor":"#0097FF","stopOpacity":"0.1922"}}/>
                  <stop offset="0.8754" style={{"stopColor":"#0069FF","stopOpacity":"0.1243"}}/>
                  <stop offset="0.9426" style={{"stopColor":"#0034FF","stopOpacity":"5.729613e-02"}}/>
                  <stop offset="1" style={{"stopColor":"#0000FF","stopOpacity":"0"}}/>
                </linearGradient>
                <path className="st3" style={{fill:"url('#SVGID_1_')"}} d="M175.8,179.3c0,0-0.1,0-0.1,0 M175.1,179.4c-0.3,0-0.5,0-0.8-0.1C174.6,179.4,174.8,179.5,175.1,179.4
              c0.1,0,0.2,0,0.2,0C175.2,179.4,175.2,179.4,175.1,179.4z M175.1,179.4c-0.3,0-0.5,0-0.8-0.1
              C174.6,179.4,174.8,179.5,175.1,179.4c0.1,0,0.2,0,0.2,0C175.2,179.4,175.2,179.4,175.1,179.4z"/>
                <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="817.6351" y1="124.0774" x2="181.4779"
                                y2="124.0774">
                  <stop offset="7.086212e-03" style={{"stopColor":"#FFFFFF"}}/>
                  <stop offset="0.4787" style={{"stopColor":"#00FFFF","stopOpacity":0.52}}/>
                  <stop offset="0.5415" style={{"stopColor":"#00FFFF","stopOpacity":"0.4574"}}/>
                  <stop offset="0.6066" style={{"stopColor":"#00EEFF","stopOpacity":"0.3924"}}/>
                  <stop offset="0.6728" style={{"stopColor":"#00BCFF","stopOpacity":"0.3264"}}/>
                  <stop offset="0.7398" style={{"stopColor":"#00BCFF","stopOpacity":"0.2596"}}/>
                  <stop offset="0.8073" style={{"stopColor":"#0097FF","stopOpacity":"0.1922"}}/>
                  <stop offset="0.8754" style={{"stopColor":"#0069FF","stopOpacity":"0.1243"}}/>
                  <stop offset="0.9426" style={{"stopColor":"#0034FF","stopOpacity":"5.729613e-02"}}/>
                  <stop offset="1" style={{"stopColor":"#0000FF","stopOpacity":"0"}}/>
                </linearGradient>
                <path className="st4" style={{fill: "url('#SVGID_2_')"}} d="M829,239.6c-28.1-69.1-75.6-128.1-137.4-170.4C628.4,25.8,554.3,2.9,477.2,2.9
              c-127.3,0-245.5,63.3-316.1,169.2c-0.8,1.2-1,2.6-0.5,3.9c0.5,1.3,1.5,2.4,2.8,2.8l9.9,3.3c0.6,0.2,1.2,0.3,1.8,0.3
              c1.8,0,3.5-0.9,4.6-2.4c32.4-47.5,76.2-87.1,126.7-114.5c52.1-28.2,111.2-43.2,170.9-43.2c72,0,141.6,21.2,201,61.4
              c58,39.2,103.1,93.9,130.3,158.2c0.8,1.9,2.7,3.2,4.8,3.2h11.8c1.4,0,2.6-0.7,3.4-1.8C829.4,242.3,829.5,240.8,829,239.6z
               M175.1,179.5c-0.3,0-0.5,0-0.8-0.1C174.6,179.4,174.8,179.4,175.1,179.5c0.1,0,0.1,0,0.2,0
              C175.2,179.4,175.2,179.5,175.1,179.5z M810.9,243.6c0.2,0.2,0.5,0.3,0.7,0.4C811.4,243.9,811.2,243.8,810.9,243.6z"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(DisneyPlusLogo);
export default DisneyPlusLogo;



// WEBPACK FOOTER //
// ./client/src/components/logos/DisneyPlusLogo.jsx